import { render, staticRenderFns } from "./TopUpAccountWalletModal.vue?vue&type=template&id=10d3cb5a&scoped=true&"
import script from "./TopUpAccountWalletModal.vue?vue&type=script&lang=js&"
export * from "./TopUpAccountWalletModal.vue?vue&type=script&lang=js&"
import style0 from "./TopUpAccountWalletModal.vue?vue&type=style&index=0&id=10d3cb5a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d3cb5a",
  null
  
)

export default component.exports